import React, { Component } from "react";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import moment from "moment";

import CustomTableHead from "../../../../Components/Table/CustomTableHeader/CustomTableHeader";

class IssuedBook extends Component {
  constructor(props) {
    super(props);
    this.state = {
      column: [
        { name: "S.N." },
        { name: "Book" },
        { name: "Issued Date" },
        { name: "Due Date" },
        { name: "Remaining Days" },
        { name: "Return Status" },
      ],
    };
  }

  getDays = (dueDate) => {
    let date1 = moment(new Date());
    let date2 = moment(dueDate);
    let diff = date2.diff(date1, "days");
    return diff;
  };

  render() {
    const { issued } = this.props;
    return (
      <TableContainer>
        <Table>
          <CustomTableHead column={this.state.column} />
          <TableBody>
            {issued.map((book, index) => (
              <TableRow key={index}>
                <TableCell align="center">{index + 1}</TableCell>
                <TableCell align="center">{book.title}</TableCell>
                <TableCell align="center">
                  {moment(book.issuedDate).format("LL")}
                </TableCell>
                <TableCell align="center">
                  {moment(book.dueDate).format("LL")}
                </TableCell>
                {this.getDays(book.dueDate) < 0 ? (
                  <TableCell align="center" style={{ color: "red" }}>
                    {Math.abs(this.getDays(book.dueDate))} extra days
                  </TableCell>
                ) : (
                  <TableCell align="center" style={{ color: "green" }}>
                    {this.getDays(book.dueDate) + 1} days
                  </TableCell>
                )}
                {book.returnDate ? (
                  <TableCell align="center" style={{ color: "green" }}>
                    Returned
                  </TableCell>
                ) : (
                  <TableCell align="center" style={{ color: "red" }}>
                    Not Returned Yet
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
}

export default IssuedBook;
